import { Link } from 'react-router';
import { Tag } from '@/components/Tag';
import { shortDate } from '@/lib/format';
import { amountRows, KitNote, targetOf, titleOf, TypeMark } from './ExceptionBits';
import { isOpen, recommended, responsibility, resolution, statusOf } from './status';
import { exceptionHref } from './api';
import type { ExceptionItem } from './types';
import s from './ExceptionCard.module.css';

/**
 * 异常卡（手机列表、iPad 列表栏）：类型 + 标题 + 状态（全卡唯一实底标签）/ 套装上下文 / 订单·客户 / 说明 / 责任·批次·登记。
 * 金额只在有 orders.amount.read 时出现；未闭环卡片可按权限直接处理或关闭。
 */
export function ExceptionCard({ e, to, selected, showAmount, canClose, canResolve, onClose, onResolve }: {
  e: ExceptionItem;
  to?: string;
  selected?: boolean;
  showAmount: boolean;
  canClose?: boolean;
  canResolve?: boolean;
  onClose?: (item: ExceptionItem) => void;
  onResolve?: (item: ExceptionItem) => void;
}) {
  const st = statusOf(e.status);
  const t = targetOf(e);
  const amounts = showAmount ? amountRows(e) : [];
  return (
    <article className={[s.card, selected && s.sel].filter(Boolean).join(' ')}>
    <Link to={to || exceptionHref(e)} state={{ seed: e }} className={s.main} aria-current={selected || undefined}>
      <div className={s.t}>
        <TypeMark type={e.type} />
        <b>{titleOf(e)}</b>
        <Tag tone={st.tone} sm>{st.label}</Tag>
      </div>
      {t.bundle && <div className={s.k}><KitNote name={t.bundle} code={t.bundleCode} /><span>的组件</span></div>}
      <p className="tnum">{e.order.orderNo} · {e.order.customer.name}</p>
      {e.note && <q className={s.q}>{e.note}</q>}
      <div className={s.kv}>
        <span><i>责任</i>{e.responsibility ? responsibility[e.responsibility] || e.responsibility : '待判定'}</span>
        <span><i>批次</i>{e.shipment ? <span className="tnum">{e.shipment.shipmentNo}</span> : '订单级'}</span>
        <span><i>登记</i>{shortDate(e.createdAt)} {e.createdBy?.name || ''}</span>
        {e.resolutionAction && <span><i>处理</i>{resolution[e.resolutionAction] || e.resolutionAction}</span>}
        {amounts.map(([k, v]) => <span key={k}><i>{k}</i><b className="tnum">{v}</b></span>)}
      </div>
      {isOpen(e) && <div className={s.next}>下一步：{recommended(e)}</div>}
    </Link>
    {isOpen(e) && (canClose || canResolve) && <div className={s.actions}>
      {canClose && <button type="button" onClick={() => onClose?.(e)}>关闭</button>}
      {canResolve && e.canOperate && <button type="button" className={s.primary} onClick={() => onResolve?.(e)}>处理</button>}
    </div>}
    </article>
  );
}
